import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'events',
    loadChildren: () =>
      import('../../pages/events/events.module').then(
        (m) => m.EventsModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('../../pages/home/home.module').then(
        (m) => m.HomeModule
      ),
  },
  {
    path: 'my-profile',
    loadChildren: () =>
      import('../../pages/my-profile/my-profile.module').then(
        (m) => m.MyProfileModule
      ),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('../../pages/about-us/about-us.module').then(
        (m) => m.AboutUsModule
      ),
  },
  {
    path: 'session',
    loadChildren: () =>
      import('../../pages/session/session.module').then(
        (m) => m.SessionModule
      ),
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('../../pages/payment/payment.module').then(
        (m) => m.PaymentModule
      ),
  },
  {
    path: 'cart',
    loadChildren: () =>
      import('../../pages/shoppingcart/shoppingcart.module').then(
        (m) => m.ShoppingcartModule
      ),
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('../../pages/checkout/checkout.module').then(
        (m) => m.CheckoutModule
      ),
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('../../pages/contact/contact.module').then(
        (m) => m.ContactModule
      ),
  }, {
    path: 'privacy-policy',
    loadChildren: () =>
      import('../../pages/superaripolicy/superaripolicy.module').then(
        (m) => m.SuperariPolicyModule
      ),
  },
  {
    path: 'terms-conditions',
    loadChildren: () =>
      import('../../pages/terms-and-conditions/terms-and-conditions.module').then(
        (m) => m.TermsAndConditionsModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule { }
